import React from "react";
import "../Style/social.css";

const Social = () => {
  return (
    <div id="social">
      <div id="git">
        {" "}
        <a target="blank" href="https://github.com/iamitpal">
          <i style={{ color: "black" }} class="fa-brands fa-github"></i>
        </a>
      </div>
      <div id="link">
        {" "}
        <a target="blank" href="https://www.linkedin.com/in/iamitpal/">
          {" "}
          <i style={{ color: "royalblue" }} class="fa-brands fa-linkedin"></i>
        </a>
      </div>
    </div>
  );
};

export default Social;
